const purchaseTypes = {
  NONE: 1,
  MAKE_OFFER: 2,
  BUY_NOW: 3,
  TRANSFER: 4,
  TENDER: 5,
  TENDER_PCT: 6
}

export default purchaseTypes
